import { colors } from 'theme/colors';

import AiEnabledActionsIcon from 'components/icons/AiEnabledActionsIcon';

export const AiStatus = {
  color: 'lime',
  borderColor: colors.lime5,
  icon: <AiEnabledActionsIcon />,
};

export const Default = {
  color: 'default',
  borderColor: colors.ledgerWhite5,
  icon: null,
};

export const Gold = {
  color: 'gold',
  borderColor: colors.gold3,
  icon: null,
};

export const Green = {
  color: 'green',
  borderColor: colors.subtleMint6,
  icon: null,
};

export const Cyan = {
  color: 'cyan',
  borderColor: colors.cyan3,
  icon: null,
};

export const White = {
  color: 'default',
  borderColor: colors.ledgerWhite5,
  icon: null,
};

export const Blue = {
  color: 'blue',
  borderColor: colors.blue3,
  icon: null,
};

export const Orange = {
  color: 'orange',
  borderColor: colors.orange3,
  icon: null,
};

export const Purple = {
  color: 'purple',
  borderColor: colors.purple3,
  icon: null,
};

export const Red = {
  color: 'red',
  borderColor: colors.red3,
  icon: null,
};

/** Maps a preset color name to its matching borderColor for use by <Tag color="..."> */
export const COLOR_BORDER_MAP: Record<string, string> = Object.fromEntries(
  [AiStatus, Default, Gold, Green, Cyan, Blue, Orange, Purple, Red]
    .filter((c) => c.borderColor)
    .map((c) => [c.color, c.borderColor])
);
